module.exports = __webpack_public_path__ + "img/feedback_time_five_minutes__.48e8f536.gif";